







































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

import {dateFormat} from "@/script/moment";
import {AxiosError, AxiosResponse} from "axios";
import FollowBtn from "@/components/user/_followBtn.vue";
import {mapGetters} from "vuex";
import {User} from "@/types";
import LikeBtn from "@/components/timeline/_likeBtn.vue";
import UserAvatar from "@/components/user/_userAvatar.vue";
import {execCommandCopy} from "@/script/util";
import Toast from "@/script/message";
import CommentInput from "@/components/comment/_commentInput.vue";
import Comment from "@/components/timeline/Comment.vue";
import {scrollDone} from "@/script/scrollManager";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import Post from "@/components/timeline/_post.vue";

@Component({
    components: {
        FollowBtn,
        LikeBtn,
        UserAvatar,
        CommentInput,
        Comment,
        Swiper,
        SwiperSlide,
        Post

    },
    computed: {...mapGetters(["user"])},
})
export default class FeedDetail extends Vue {
    toast = new Toast();
    feedId = this.$route.params.feedId;
    feed: any = null;
    createdDate: string = "";
    commentId: string = '';

    originImg: string = "";
    needLogin = false;
    user!: User;
    comments: any = [];
    limit: number = 10;
    offset: number = 0;
    sort: string = '';

    isAddData: boolean = false;
    swiperOption = {
        pagination: {
            el: '.swiper-pagination'
        }
    }

    isOpenReportModal = false;
    pickedReason: any = '';
    mounted() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch();
                this.commentFetch();
            })

        window.addEventListener("scroll", this.scrollCheck);
    }

    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollCheck);
    }

    sendReport() {
        const obj = {
            post_id: this.feedId,
            user_id: this.user.id,
            targetType: 'POST',
            report_reason: this.pickedReason
        }
        this.$api.reportPost(obj)
            .then((res: AxiosResponse) => {

            })
            .catch((err: AxiosError) => {

                this.toast.failToast(err.message)
            })
            .finally(() => {
                this.$modal.hide('modalReport')
                this.pickedReason = ''
            })
    }

    fetch() {
        this.$api.feed(this.feedId)
            .then((res: AxiosResponse) => {
                this.feed = res;
                this.createdDate = dateFormat(this.feed.createdAt)!;
            })
    }

    reFetch() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch();
                this.generateKey();
                this.$store.dispatch('reloadUserInfo')

            })
    }

    copyUrl() {
        execCommandCopy(window.location.href)
        this.toast.clear();
        this.toast.successToast(`${this.$t('copied.clipboard')}`)
    }

    scrollCheck() {
        if (scrollDone(document.documentElement)) {
            this.offset += this.limit;
            this.commentFetch();
        }

    }


    openEdit() {
        this.$modal.show('modalPost')
        this.$store.commit('feed', this.feed)
    }

    commentInit() {
        this.comments = [];
        this.limit = 10;
        this.offset = 0;
        this.sort = '';
        window.addEventListener("scroll", this.scrollCheck);
    }

    commentFetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            sort: this.sort
        }
        this.$api.comments(this.feedId, obj)
            .then((res: any) => {
                if (this.isAddData) {
                    if (res.result.length > 0) {
                        this.comments = [...this.comments, ...res.result]
                    }
                    else {
                        window.removeEventListener("scroll", this.scrollCheck);
                    }
                }
                else {
                    this.comments = res.result;
                    this.isAddData = true
                }
            })
            .catch((err: AxiosError) => {

            })
            .finally(() => {

            })
    }

    beforeOpen(event) {
        this.commentId = event.params.commentId;

    }

    deleteComment() {
        this.commentInit();
        this.$api.deleteComment(this.feedId, this.commentId)
            .then((res: AxiosResponse) => {
                this.$modal.hide('deleteComment')
                this.commentFetch()
                this.fetch();

            })
            .catch((err: AxiosError) => {

            })
    }

    editDone() {
        this.fetch();
        this.commentInit();
        this.commentFetch()
    }

    contentClicked(e: any) {
        if (e.target.matches("img")) {
            this.originImg = e.target.src;
            (this.$refs.originImgModal as any).show();
        }
        else if (e.target.matches(".hashtag")) {
            this.$router.push(`/${this.$i18n.locale}/search?hashtag=${e.target.attributes["data-id"].nodeValue}`);
        }
        else if (e.target.matches(".mention")) {
            this.$router.push(`/${this.$i18n.locale}/channel/${e.target.attributes["channel-id"].nodeValue}/timeline`);
        }
    }

    closeImgModal() {
        (this.$refs.originImgModal as any).hide();
    }

    generateKey() {
        return Date.now();
    }

    deletePost() {
        this.$emit('deleteFeed', this.feed.id)
        this.$modal.show('deleteModal')
    }

    yesDeletePost() {
        this.$modal.hide('deleteModal')


        this.$api.deletePost(this.feedId)
            .then((res: any) => {
                if (res.success) {
                    this.$toasted.clear();
                    this.toast.successToast(`${this.$t('posting.deleted')}`)
                }
                this.$router.push(`/${this.i18n.locale}`)
            })
            .catch((err: any) => {

            })
    }

    report() {
        this.$emit('reportPost', this.feed.id)
        this.isOpenReportModal = !this.isOpenReportModal
        this.$modal.show('modalReport')
    }

}
